<ion-list>
  <ion-list-header lines="full">
    <ion-label>
      <h2>Acciones</h2>
    </ion-label>
  </ion-list-header>
  <ion-item *ngIf="!selectFile === true" button lines="none" (click)="continueWhereItLeftOff()">
    <ion-label>Continuar envío donde se quedó</ion-label>
  </ion-item>
  <ion-item *ngIf="selectFile === true" button lines="none" (click)="selectFileAlert()">
    <ion-label>Seleccionar nuevo archivo</ion-label>
  </ion-item>
</ion-list>